import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const DealershipFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  isExpanded, 
  onToggleExpanded 
}) => {
  const hasActiveFilters = filters?.search;

  return (
    <div className="bg-card rounded-lg border border-border">
      {/* Filter Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-muted-foreground" />
          <h3 className="font-medium text-foreground">Filter</h3>
          {hasActiveFilters && (
            <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full">
              Aktiv
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              className="text-muted-foreground"
            >
              <Icon name="X" size={16} className="mr-1" />
              Zurücksetzen
            </Button>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggleExpanded}
            className="lg:hidden"
          >
            <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={20} />
          </Button>
        </div>
      </div>
      {/* Filter Content */}
      <div className={`${isExpanded ? 'block' : 'hidden'} lg:block p-4 space-y-4`}>
        {/* Search */}
        <div>
          <Input
            type="search"
            placeholder="Autohaus, Stadt oder Kontakt suchen..."
            value={filters?.search}
            onChange={(e) => onFilterChange({ ...filters, search: e?.target?.value })}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default DealershipFilters;